import {Component, ComponentOptions} from "@mecatran-components/component";
import {SearchBox} from "@mecatran-components/searchbox";
import {BackButton} from "./backbutton.component.mjs";

export class SearchBar extends Component{
    constructor(type){
       super();

        this.initSearchBar(type)

    }

    /* ======================================= */
    /* Private                                 */
    /* ======================================= */
    createBackButton(){
        return new BackButton();
    }

    createSearchBox(type){
        var placeholder;
        switch(type){
            case 'school':
                placeholder = "Choisir un établissement";
                break; 
            case 'home':
                placeholder = "Choisir un arrêt attaché à l'établissement"
        }
        var inputOptions = { 
            placeholder ,
            classList : ['search']
        }
        var domOptions = {
            id: 'test1',
            classList : ['search-box']
        }
        var clearButtonUrl = './assets/cross.png'
        var options = { domOptions , inputOptions, clearButtonUrl }
        var searchBox = new SearchBox(options);
        return searchBox;
    }

    initSearchBar(type){
        if (type !== 'school'){
            var backButton = this.createBackButton();
            this.addSubComponent(backButton,'backButton');
        }
        var searchBox = this.createSearchBox(type);
        this.addSubComponent(searchBox, 'searchBox');
        this.build();
    }

    /* ======================================= */
    /* Overload                                */
    /* ======================================= */

    createContainerNode(){
        var div = document.createElement('div');
        div.setAttribute('class','search-bar');
        return div; 
    }

    createContentNode(){ return; }

    defineEventListeners(eventManager){
        //eventManager.on('clearEvent')
    }

    /* ======================================= */
    /* Public                                  */
    /* ======================================= */   
    setValue(value){
        var searchBox = this.getStorageManager().getComponents('searchBox')[0];
        searchBox.setValue(value);
    }


}